// import {AppConfig} from '../../AppConfig'
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { AppConfig } from '../entities/AppConfig';
import 'rxjs/Rx';
import 'rxjs/add/operator/toPromise';
import { of } from 'rxjs';
import { Constants } from '../constants/Constants';
import { Settings } from '../constants/Settings';

@Injectable()
export class ConfigService {

  public appConfig: AppConfig;

  constructor(public http: Http) { }

  public getConfigs(): Promise<AppConfig> {
    let appConfig: AppConfig =  
    {
      Version: Settings._UI_VERSION,
      UrlBase: Settings._URL_BASE,
      TenantName: Constants._TENANT_NAME,
      LoginRedirectUrl: ""
    }

    
    const o=of(appConfig);

    return o.toPromise().then(x=> this.appConfig = x);

    //return Promise.resolve(appConfig);

    

    // return new Promise(resolve => {
    //     resolve(appConfig);
    // }).then(x=> {return appConfig});
  }

  

  getConfigsDone(obj: any): AppConfig {
    this.appConfig = obj;
    this.appConfig.UrlBase = obj.UrlBase;
    this.appConfig.Version = obj.Version;
    this.appConfig.LoginRedirectUrl = obj.LoginRedirectUrl;
    return this.appConfig;
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}
